// removed by extract-text-webpack-plugin
module.exports = {"senderInfo":"gTcj42GjqdyZw7a5u_LmR","senderName":"_2lsV0Czi9a9mK4pmcIoVXQ","deleteSenderContainer":"_2HGOeEcTImy8qWs_B_pAEr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectSenderInfo/ProjectSenderInfo.scss
// module id = 1370
// module chunks = 1